import React from "react";
import { ActionIcon, Tooltip } from "@mantine/core";
import { useLang } from "./language";
import { T } from "./translator";

export const PLAYBACK_RATES = [1, 1.5, 2];
export const nextPlaybackRate = (rate) => PLAYBACK_RATES[(PLAYBACK_RATES.indexOf(rate) + 1) % PLAYBACK_RATES.length];

export default function AudioPlaybackSpeed({ rate, onClick, disabled, color }) {
	const { lang } = useLang();
	const label = T("audioPlaybackSpeed", lang).replace("{rate}", `${rate}×`);
	return (
		<Tooltip label={label}>
			<ActionIcon type="button" onClick={onClick} disabled={disabled} aria-label={label}
				size={40} radius="xl" style={{ flexShrink: 0, color }}>
				<svg width="36" height="36" viewBox="0 0 36 36" aria-hidden="true">
					<circle cx="18" cy="18" r="15" fill="none" stroke="currentColor" strokeWidth="2" strokeDasharray="3 3" />
					<text x="18" y="19" textAnchor="middle" dominantBaseline="middle" fill="currentColor"
						style={{ fontFamily: "inherit", fontSize: 11, fontWeight: 700 }}>{rate}×</text>
				</svg>
			</ActionIcon>
		</Tooltip>
	);
}
